(() => {
    'use strict';

    real.events.on('page:exam:enabled', (notification) => {
        if (real.dom.$body.data('page-id') === notification.object.page.id) {
            $('#top .page-buttons .exam-related').removeClass('d-none');
        }
    });

    real.events.on('page:exam:disabled', (notification) => {
        if (real.dom.$body.data('page-id') === notification.object.page.id) {
            $('#top .page-buttons .exam-related').addClass('d-none');
            howspace.animate($('.my-exam-results-container:visible'), 'slideUp', 'fast');
        }
    });

    real.events.on('exam:answer:created', (notification) => {
        if (real.dom.$body.data('page-id') === notification.object.page.id && notification.object.exam_completed) {
            $('.show-my-exam-results-btn').prop('disabled', false);
            howspace.animate($('.my-exam-results-container:hidden'), 'slideDown', 'fast');
        }

        const widget = $('#widget-' + notification.object.widget.id);
        if (widget.length > 0) {
            widget.dataAndAttr('answer-id', notification.object.answer.id);
            howspace.workspace.page.pathMode.handleUserHasInteracted(widget);
            removeSelectedOptionIds(widget);
            if (!widget.hasClass('updating') && !widget.hasClass('removing')) {
                howspace.widgets.updateWidget(widget, 'view');
            }
        }
    });

    real.events.on('exam:answer:deleted', (notification) => {
        if (real.dom.$body.data('page-id') === notification.object.page.id) {
            $('.show-my-exam-results-btn').prop('disabled', true);
            howspace.animate($('.my-exam-results-container:visible'), 'slideUp', 'fast', () => {
                // Disable Show certificate button.
                $('.show-certificate-btn').prop('disabled', true);
            });
        }

        const widget = $('#widget-' + notification.object.widget.id + ':not(.updating,.removing)');
        if (widget.length > 0) {
            howspace.workspace.page.pathMode.handleUserHasNotInteracted(widget);
            howspace.widgets.updateWidget(widget, 'view');
        }
    });

    const deleteAnswer = (widget, successFn) => {
        if (widget.data('answer-id')) {
            real.ajax.json(howspace.widgets.getApiUrl(widget) + '/examanswer/' + widget.data('answer-id'), {
                type: 'DELETE',
                success: successFn
            });
        } else {
            successFn();
        }
    };

    const submitAnswer = (widget) => {
        const dataPayload = {
            selected_options: []
        };

        widget.find('.options-wrapper .exam-option.selected').each(function () {
            dataPayload.selected_options.push($(this).data('id'));
        });

        real.ajax.json(howspace.widgets.getApiUrl(widget) + '/examanswers', {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            logError: response => {
                return response.status !== 409;
            },
            showErrorNotification: response => {
                return response.status !== 409;
            },
            error: response => {
                real.ajax.loopErrors(response, function (error) {
                    if (error.code === 409) {
                        // User has already answered to exam, but UI didn't update fast enough and now
                        // user is trying to answer again and conflict occurred. Just update the
                        // whole widget UI at this point.
                        howspace.widgets.updateWidget(widget, 'view');
                    }
                });
            }
        });
    };

    const setSelectedOptionIds = widget => {
        const optionIds = widget.find('.options-wrapper .exam-option.selected').map(function () {
            return $(this).data('id');
        }).get();
        real.localStorage.set(widget.prop('id') + '-selected-option-ids', optionIds)
    };

    const removeSelectedOptionIds = widget => {
        real.localStorage.remove(widget.prop('id') + '-selected-option-ids');
    };

    const getSelectedOptionIds = widget => {
        const optionIds = real.localStorage.get(widget.prop('id') + '-selected-option-ids');
        if (optionIds) {
            widget.find('.options-wrapper .exam-option').filter(function () {
                return optionIds.includes($(this).data('id'));
            }).addClass('selected');

            const selectOptionsMin = 1;
            const selectOptionsMax = widget.data('select-options-max');

            const selected = widget.find('.options-wrapper .exam-option.selected').length;
            widget.find('.submit-btn').prop('disabled', selected < selectOptionsMin || selected > selectOptionsMax);
        }
    };

    const getOptionIndex = index => {
        return String.fromCharCode(index % 26 + 65);
    };

    const selectOption = (widget, option) => {
        const submitBtn = widget.find('.submit-btn');

        const selectOptionsMin = 1;
        const selectOptionsMax = widget.data('select-options-max');
        let selectedCount = widget.find('.options-wrapper .exam-option.selected').length;

        if (!option.is('.selected')) {
            if (selectOptionsMax === 1) {
                widget.find('.options-wrapper .exam-option').removeClass('selected').attr('aria-checked', 'false');
            } else if (selectedCount === selectOptionsMax) {
                return;
            }
        } else if (selectOptionsMax === 1) {
            return;
        }

        option.toggleClass('selected');
        option.attr('aria-checked', option.is('.selected') ? 'true' : 'false');

        selectedCount = widget.find('.options-wrapper .exam-option.selected').length;
        submitBtn.prop('disabled', selectedCount < selectOptionsMin || selectedCount > selectOptionsMax);

        setSelectedOptionIds(widget);
    };

    real.events.on('exam:certificate:created', notification => {
        $('.show-certificate-btn')
            .attr('disabled', false)
            .on('click', e => {
                e.preventDefault();
                window.open(notification.object.certificate.download_url, '_blank');
            });
    });

    real.dom.$body.on('click', '.try-again-btn', () => {
        const dataPayload = {
            '_action': 'exam_try_again'
        };

        real.ajax.json(real.baseUri + '/api/page/' + real.dom.$body.data('page-id'), {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            success: () => {
                howspace.workspace.page.show(real.dom.$body.data('page-path'));
            }
        });
    });

    howspace.widgets.exam = {
        initView: widget => {
            const submitBtn = widget.find('.submit-btn');
            const selectOptionsMax = widget.data('select-options-max');

            // Save selected options to local storage.
            widget.find('.options-wrapper .exam-option').on('click', e => {
                const option = $(e.target).closest('.exam-option');
                selectOption(widget, option);
            });

            widget.find('.options-wrapper .exam-option').on('keydown', e => {
                const changeFn = option => {
                    if (selectOptionsMax === 1) {
                        option.click();
                    }
                };

                const selectFn = option => {
                    option.click();
                }

                howspace.components.keyboard.onItemGroupKeyDown(e, '.options-wrapper', '.exam-option', changeFn, selectFn);
            });

            // Submit answer.
            submitBtn.on('click', e => {
                const btn = $(e.target);
                real.button.loading(btn, widget);

                deleteAnswer(widget, () => {
                    submitAnswer(widget);
                })
            });

            // Remove answer
            widget.find('.delete-answer-btn').on('click', e => {
                const btn = $(e.target);
                real.button.loading(btn, widget);
                deleteAnswer(widget);
            });

            // Change answer.
            widget.find('.change-answer-btn').on('click', () => {
                removeSelectedOptionIds(widget);
                widget.find('.change-answer-btn').addClass('d-none');
                widget.find('.results-wrapper').addClass('d-none');
                widget.find('.options-wrapper').removeClass('d-none');
                widget.find('.options-wrapper .exam-option.selected:first').focus();
            });

            if (widget.find('.options-wrapper').is(':visible')) {
                // Restore user selections from local storage.
                getSelectedOptionIds(widget);
            }
        },
        destroyView: () => {
            // Empty for now.
        },
        initEdit: widget => {
            // Add option button.
            widget.find('.add-option-btn').on('click', () => {
                widget.find('.exam-options').removeClass('d-none');

                const count = widget.find('.exam-option-wrapper').length;
                const sortableList = widget.find('.howspace-sortable-list');
                const option = howspace.components.sortableList.addItem(sortableList);

                if (count === 0) {
                    option.find('input[name="is_correct"]').click();
                }

                option.find('.index').text(getOptionIndex(count));
            });

            // Item moved event
            widget.on(howspace.components.sortableList.ITEM_MOVED, item => {
                widget.find('.exam-option-wrapper').each(function (index) {
                    const option = $(this);
                    option.find('.index').text(getOptionIndex(index));
                });
            });
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        save: (widget, dataPayload) => {
            dataPayload.exam_options = [];
            widget.find('.exam-option-wrapper:not(.deleted)').each(function () {
                dataPayload.exam_options.push(real.form.getDataPayload($(this)));
            });
            return dataPayload;
        },
        initExamSettingsModal: modal => {
            modal = $(modal);

            modal.on('click', '.save-button', () => {
                const dataPayload = {
                    exam_settings: real.form.getDataPayload(modal)
                };

                real.ajax.json(`${real.baseUri}/api/page/${real.dom.$body.data('page-id')}`, {
                    type: 'POST',
                    data: JSON.stringify(dataPayload),
                    complete: () => {
                        window.location.reload();
                    }
                });
            });
        },
        initMigrateModal: modal => {
            modal = $(modal);

            modal.on('click', '.btn-success', () => {
                const btn = modal.find('.migrate-button');
                real.button.loading(btn, modal);

                const dataPayload = {
                    _action: 'exam_migrate'
                };

                real.ajax.json(`${real.baseUri}/api/page/${real.dom.$body.data('page-id')}`, {
                    type: 'POST',
                    data: JSON.stringify(dataPayload),
                    success: function () {
                        howspace.components.modal.close(modal);
                    },
                    error: function () {
                        real.button.reset(btn);
                    }
                });
            });
        },
        initResultsModal: modal => {
            modal = $(modal);

            modal.on(howspace.components.lister.LIST_ITEMS_RENDERED, (e) => {
                const lister = $(e.target);
                const container = lister.closest('.exam-results-content');
                const sendEmailButtons = container.find('.send-emails-btn');

                if (lister.data('total-items') === 0) {
                    sendEmailButtons.prop('disabled', true);
                    sendEmailButtons.addClass('disabled');
                } else {
                    sendEmailButtons.prop('disabled', false);
                    sendEmailButtons.removeClass('disabled');
                }
            });
        }
    };
})();
